import { memo, useId, type SVGProps } from "react";

import { withUniqueSvgIds } from "./withUniqueSvgIds";

const SvgValetParking = (props: SVGProps<SVGSVGElement>) => {
  const idPrefix = useId().replace(/:/g, "");

  return withUniqueSvgIds(
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="m15.5 21-.5-6-1.5-1v-4q0-.82.59-1.41.59-.6 1.41-.59h.5l1 2 1-2h.5q.83 0 1.41.59.6.59.59 1.41v4L19 15l-.5 6zM17 7q-.83 0-1.41-.59-.6-.58-.59-1.41h4q0 .82-.59 1.41-.59.6-1.41.59m-2-3V3q0-.42.29-.71.29-.3.71-.29h2q.42 0 .71.29.3.29.29.71v1zM8 21a1 1 0 0 1-.71-.29A1 1 0 0 1 7 20v-1H2v-2h6v-5H2v-2h5.2L6.15 7H2V5h4.5a1.5 1.5 0 0 1 1.4 1l2.1 6v8q0 .42-.29.71-.29.3-.71.29zm-2.5-5q.63 0 1.06-.44.44-.43.44-1.06t-.44-1.06q-.43-.45-1.06-.44-.63 0-1.06.44Q4 13.87 4 14.5t.44 1.06q.43.45 1.06.44"
      />
    </svg>,
    idPrefix,
  );
};

const Memo = memo(SvgValetParking);
export default Memo;
